import { render, staticRenderFns } from "./category-dialog.vue?vue&type=template&id=ee862eba&"
import script from "./category-dialog.vue?vue&type=script&lang=js&"
export * from "./category-dialog.vue?vue&type=script&lang=js&"
import style0 from "./category-dialog.vue?vue&type=style&index=0&id=ee862eba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports